import instance from "../utils/network";
import { RankingInfoResponse, RankingResponse } from "./runner-ranking";

export function getMemberWeekRanking(
  pubId: number,
  year: number,
  week: number,
  limit: number,
  page: number
): Promise<RankingResponse> {
  return instance.get(
    `/nest/member-ranking?&limit=${limit}&page=${page}&year=${year}&week=${week}&pubId=${pubId}`
  );
}
export function getMemberMonthRanking(
  pubId: number,
  year: number,
  month: number,
  limit: number,
  page: number
): Promise<RankingResponse> {
  return instance.get(
    `/nest/member-ranking?&limit=${limit}&page=${page}&year=${year}&month=${month}&pubId=${pubId}`
  );
}
export function getMemberRanking(
  season: number,
  pubId: number,
  limit: number,
  page: number
): Promise<RankingResponse> {
  return instance.get(
    `/nest/member-ranking?season=${season}&limit=${limit}&page=${page}&pubId=${pubId}`
  );
}

export function getMemberWeekRankingInfo(
  id: number
): Promise<RankingInfoResponse> {
  return instance.get(`/nest/member-ranking/week-info/${id}`);
}

export function getMemberMonthRankingInfo(
  id: number
): Promise<RankingInfoResponse> {
  return instance.get(`/nest/member-ranking/month-info/${id}`);
}

export function getMemberRankingInfo(id: number): Promise<RankingInfoResponse> {
  return instance.get(`/nest/member-ranking/info/${id}`);
}
